import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { StahliaSidebar } from "./shell/StahliaSidebar";
import { StahliaTopBar } from "./shell/StahliaTopBar";
import { TweaksPanel } from "./shell/TweaksPanel";

export default function Layout() {
  return (
    <div
      className="min-h-screen bg-background text-foreground grid"
      style={{ gridTemplateColumns: "var(--sidebar-w) 1fr" }}
    >
      <StahliaSidebar />
      <div className="flex flex-col min-w-0 min-h-screen">
        <StahliaTopBar />
        {/* Seiten mit klebendem Tabellenkopf (DataTable stickyHeader) scrollen am Dokument:
            dort darf main kein Scrollport sein, sonst klebt der Kopf nie. */}
        <main className="flex-1 overflow-auto has-[[data-seiten-scroll]]:overflow-x-clip has-[[data-seiten-scroll]]:overflow-y-visible">
          <Outlet />
        </main>
      </div>
      <TweaksPanel />
      <Toaster position="bottom-right" theme="system" />
    </div>
  );
}
